module.exports = __webpack_public_path__ + "media/challenge_flow/images/icons/arrow-right-7056e906000db896b785b3213dc53b96.svg";